/** Single source of truth for all language dropdowns (questions + paper template subsections). */
export const availableLanguages = [
    {
      value: 'english',
      label: 'English',
    },
    {
      value: 'hindi',
      label: 'Hindi',
    },
    {
      value: 'tamil',
      label: 'Tamil',
    },
    {
      value: 'telugu',
      label: 'Telugu',
    },
    {
      value: 'kannada',
      label: 'Kannada',
    },
    {
      value: 'malayalam',
      label: 'Malayalam',
    },
    {
      value: 'marathi',
      label: 'Marathi',
    },
    {
      value: 'sanskrit',
      label: 'Sanskrit',
    },
    {
      value: 'english-hindi',
      label: 'English-Hindi',
    },
    {
      value: 'english-marathi',
      label: 'English-Marathi',
    },
  ]